import { Component, inject, ChangeDetectionStrategy } from '@angular/core';
import {
    MAT_DIALOG_DATA,
    MatDialogContent,
    MatDialogRef,
    MatDialogTitle,
} from '@angular/material/dialog';
import { MutationInput } from 'src/app/api/graphql/mutation-input';
import { FormComponent } from '../form/form.component';

@Component({
    selector: 'app-mutation-dialog',
    imports: [MatDialogTitle, MatDialogContent, FormComponent],
    templateUrl: './mutation-dialog.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    styleUrl: './mutation-dialog.component.css',
})
export class MutationDialogComponent {
    data: any = inject(MAT_DIALOG_DATA);
    mutationsInputs: MutationInput;
    title: string;
    context: any;

    constructor(public matDialogRef: MatDialogRef<MutationDialogComponent>) {
        this.mutationsInputs = this.data.mutationInput;
        this.title = this.data.title;
        this.context = this.data.context;
    }

    confirm(values: any) {
        this.matDialogRef.close(values ? { input: values } : { input: null });
    }
    cancel() {
        this.matDialogRef.close();
    }
}
